<template>
  <div>
    <naj-box :title="searchTitle">
      <v-row>
        <v-col
          cols="12"
          md="4"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.text"
            :label="locale.requestCode"
            :value.sync="searchQuery.requestCode"
          ></naj-input>
        </v-col>
        <v-col
          v-if="showJudgementCodeQuery"
          cols="12"
          md="4"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.text"
            :label="locale.judgementCode"
            :value.sync="searchQuery.judgementCode"
          ></naj-input>
        </v-col>
        <naj-button
          class="btn-search"
          type="button"
          color="primary"
          icon="mdi-magnify"
          :loading="loading"
          @click="search"
        >
          {{ local.common.search }}
        </naj-button>
        <naj-button
          class="btn-search"
          type="button"
          icon="mdi-repeat"
          @click="$emit('back-to-select-request')"
        >
          {{ local.common.back }}
        </naj-button>
      </v-row>
      <v-row>
      </v-row>

      <v-row v-if="requestInfo">
        <v-col cols="12">
          <request-summary :request-info="requestInfo"></request-summary>
        </v-col>
        <v-col
          v-if="requestInfo.judgementCode"
          cols="12"
        >
          <table>
            <tr class="table-header">
              <th>{{ local.bankruptcy.bankruptcyFile.judgementInfo.judgementCode }}</th>
              <th>{{ local.bankruptcy.bankruptcyFile.judgementInfo.judgementTypeName }}</th>
              <th>{{ local.bankruptcy.bankruptcyFile.judgementInfo.courtName }}</th>
              <th>{{ local.bankruptcy.bankruptcyFile.judgementInfo.subCircle }}</th>
              <th>{{ local.bankruptcy.bankruptcyFile.judgementInfo.deliveryDate }}</th>
            </tr>

            <tr>
              <th>{{ requestInfo.judgementCode }}</th>
              <th>{{ requestInfo.judgementType }}</th>
              <th>{{ requestInfo.courtName }}</th>
              <th>{{ requestInfo.subCircleName }}</th>
              <th>{{ toHijriDate(requestInfo.deliveryDate) || '---' }}</th>
            </tr>
          </table>
        </v-col>
        <naj-button
          class="btn-search"
          type="button"
          color="primary"
          :loading="loading"
          @click="$emit('select-main-request',requestInfo)"
        >
          {{ local.common.submitRequest }}
        </naj-button>
      </v-row>
    </naj-box>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import { toHijriDate } from '@/helpers/utils';
const { mapActions: mapBankruptcyActions } = createNamespacedHelpers('BankruptcyModule');
import RequestSummary from '../sub-requests/request-summary.vue';

export default {
  name: 'SearchRequestJudgement',
  inject: ['$validator'],
  components: { RequestSummary },
  props: {
    showJudgementCodeQuery: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toHijriDate,
      locale: this.local.bankruptcy.subRequests.mainRequestInquiry,
      requestCode: null,
      judgementCode: null,
      loading: false,
      requestInfo: null,
      searchQuery: {
        requestObjectKey: null,
        requestCode: null,
        judgementCode: null,
      },
    };
  },
  computed: {
    searchTitle(){
      return this.showJudgementCodeQuery?this.locale.objectionRequestTitle:this.locale.addRepresentative;
    },
  },
  watch: {},
  mounted() {
  },
  created() {
  },
  methods: {
    ...mapActions(['getUserInfo']),
    ...mapBankruptcyActions([
      'mainRequestInquiry',
    ]),
    search() {
      this.loading = true;
      this.requestInfo = null;
      this.mainRequestInquiry(this.searchQuery)
        .then(({ data }) => {
          if (data.code) {
            this.searchQuery.objectKey = data.objectKey;
            this.requestInfo = data;
          } else {
            this.toaster.error(this.local.common.notFound);
          }
        })
        .catch(err => !err.handled && this.toaster.error(err.message))
        .finally(() => (this.loading = false));
    },
  },

};
</script>

<style lang="scss" scoped>
.btn-search {
  margin: 44px;
}
.judgement-deed {
  display: flex;
  align-items: center;
  justify-content: center;
}
.memorandum-challenge-alert-container {
  .alert-notification {
    display: block;
    color: #f6c645;
    font-size: 14px;
  }
  .message {
    font-size: 16px;
    color: #faad14;
  }
}

.objection-judgment-confirm-text {
  color: darkred;
  font-size: 1rem;
  margin-bottom: 0;
}

.objection-note-attachment {
  display: flex;
  .objection-judgment-confirm-text {
    margin-left: 10px;
  }
  .uplaod-attachments-button .img-actions {
    width: 100% !important;
  }
}

::v-deep .attachment-item {
  cursor: pointer;
}
::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: #faf9f4 0% 0% no-repeat padding-box;
}
table {
  border: 1px solid #e4e5e6;
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
}
.table-header {
  border-bottom: 1px solid #e4e5e6;
}
tr {
  height: 50px;
}
th {
  text-align: center;
  padding-top: 12px;
}
</style>